import { FilterConfigFrontend, UnifiedFilterConfig } from '../types';
import { unset } from 'lodash';
import { Filter, FilterKeys } from '@nirvana/shared/dtos/types/generic-dashboards/gz-console';

export class FiltersHelper {
  public static getFilterIdForStore(filterConfig: UnifiedFilterConfig): string {
    return filterConfig.key || '';
  }

  public static filterComparer(filter1: UnifiedFilterConfig, filter2: UnifiedFilterConfig): number {
    // If one of the filters is of type Company, we want it first
    if (filter1.key === FilterKeys.COMPANY) return -1;

    if (filter2.key === FilterKeys.COMPANY) return 1;

    // If one filter is predefined and the other one isn't, put the predefined filter first
    if (FiltersHelper.isFilterPredefinedByConfig(filter1) && !FiltersHelper.isFilterPredefinedByConfig(filter2)) {
      return -1;
    }

    if (FiltersHelper.isFilterPredefinedByConfig(filter2) && !FiltersHelper.isFilterPredefinedByConfig(filter1)) {
      return 1;
    }

    // If none so far, order doesn't matter
    return 0;
  }

  public static isFilterPredefinedByConfig(filterConfig: FilterConfigFrontend) {
    return filterConfig.isDefault && !filterConfig.removable;
  }

  public static getUnifiedFilterConfigs(
    filters: Array<Filter>,
    filterConfigs: Array<FilterConfigFrontend>
  ): Array<UnifiedFilterConfig> {
    return filterConfigs.map(filterConfig => {
      const filterObj = filters.find(filter => filter[filterConfig.key]);
      const value = filterObj ? filterObj[filterConfig.key] : undefined;
      return { ...filterConfig, value };
    });
  }

  public static filterValuesFromUnifiedConfigs(unifiedFilterConfigs: Array<UnifiedFilterConfig>): Array<Filter> {
    return unifiedFilterConfigs.filter(config => config.value).map(config => ({ [config.key]: config.value }));
  }

  public static baseFilterConfigsFromUnified(
    unifiedFilterConfigs: Array<UnifiedFilterConfig>
  ): Array<FilterConfigFrontend> {
    return unifiedFilterConfigs.map(config => {
      unset(config, 'value');
      return config;
    });
  }

  public static shouldDisplayCompanyFilter() {
    return globalThis.Application.Main.company.isPartner();
  }

  public static shouldDisplayFiltersBar(filters: Filter[]): boolean {
    const hasOtherFilters = !!filters.filter(filter => !filter[FilterKeys.COMPANY]).length;
    // We should display it if there's at least 1 visible filter
    return FiltersHelper.shouldDisplayCompanyFilter() || hasOtherFilters;
  }
}
